import {
  Button,
  Checkbox,
  Grid,
  TextField,
  FormControl,
  MenuItem,
  Select,
  InputLabel,
  InputAdornment,
  FormLabel,
  FormGroup,
  FormControlLabel,
} from '@mui/material';
import Paper from '@mui/material/Paper';
import { SnapshotAlarmSettingForm } from './types';
import { Control, Controller, FieldErrors } from 'react-hook-form';

interface Props {
  control: Control<SnapshotAlarmSettingForm>;
  handleSubmit: () => void;
  hasChanges: boolean;
  errors: FieldErrors<SnapshotAlarmSettingForm>;
}

const NotificationsSetup = ({
  control,
  handleSubmit,
  hasChanges,
  errors,
}: Props) => {
  return (
    <Grid container style={{ paddingTop: '1.4rem', paddingRight: '1.4rem' }}>
      <Grid
        container
        item
        justifyContent='center'
        spacing={2}
        xs={8}
        md={6}
        lg={5}
        xl={4}
        component={Paper}
        style={{ margin: 0, paddingRight: '1.1rem', paddingBottom: '1.1rem' }}
      >
        <Controller
          name='raising_count'
          control={control}
          rules={{ required: true, min: 1 }}
          defaultValue={3000}
          render={({ field: { onChange, value } }) => (
            <Grid item xs={12}>
              <TextField
                id='raising_count'
                label='Abnormal Status Time'
                name='raising_count'
                type='number'
                value={value}
                onChange={onChange}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position='end'>ms</InputAdornment>
                  ),
                }}
                fullWidth
                error={!!errors.raising_count}
              />
            </Grid>
          )}
        />
        <Controller
          name='ignore_interval'
          control={control}
          rules={{ required: true, min: 1 }}
          defaultValue={5}
          render={({ field: { onChange, value } }) => (
            <Grid item xs={6}>
              <TextField
                id='ignore_interval'
                label='Redundant Notice Time'
                name='ignore_interval'
                type='number'
                value={value}
                onChange={onChange}
                fullWidth
                error={!!errors.ignore_interval}
              />
            </Grid>
          )}
        />
        <Controller
          name='ignore_interval_unit'
          control={control}
          rules={{ required: true }}
          defaultValue={2}
          render={({ field: { onChange, value } }) => (
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel id='ignore-interval-unit-label'>Unit</InputLabel>
                <Select
                  labelId='ignore-interval-unit-label'
                  id='ignore_interval_unit'
                  name='ignore_interval_unit'
                  label='Unit'
                  value={value}
                  onChange={onChange}
                  fullWidth
                >
                  <MenuItem value={2}>Minutes</MenuItem>
                  <MenuItem value={1}>Seconds</MenuItem>
                  <MenuItem value={0}>Milliseconds</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          )}
        />
        <Grid item xs={7}>
          <FormControl component='fieldset'>
            <FormLabel component='legend'>
              When Interference Alarm Triggered
            </FormLabel>
            <FormGroup>
              <Controller
                name='alarm_email'
                control={control}
                defaultValue={false}
                render={({ field: { onChange, value } }) => (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={!!Number(value)}
                        onChange={onChange}
                        name='alarm_email'
                      />
                    }
                    label='Send Email'
                  />
                )}
              />
              <Controller
                name='alarm_snmp'
                control={control}
                defaultValue={false}
                render={({ field: { onChange, value } }) => (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={!!Number(value)}
                        onChange={onChange}
                        name='alarm_snmp'
                      />
                    }
                    label='Send SNMP Trap/Notification'
                  />
                )}
              />
              <Controller
                name='alarm_audio'
                control={control}
                defaultValue={false}
                render={({ field: { onChange, value } }) => (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={!!Number(value)}
                        onChange={onChange}
                        name='alarm_audio'
                      />
                    }
                    label='Play Audio Alarm'
                  />
                )}
              />
            </FormGroup>
          </FormControl>
        </Grid>
        <Grid item xs={5}>
          <FormControl component='fieldset'>
            <FormLabel component='legend'>
              When Time Warning Alarm Triggered
            </FormLabel>
            <FormGroup>
              <Controller
                name='time_warning_email'
                control={control}
                defaultValue={false}
                render={({ field: { onChange, value } }) => (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={!!Number(value)}
                        onChange={onChange}
                        name='time_warning_email'
                      />
                    }
                    label='Send Email'
                  />
                )}
              />
              <Controller
                name='time_warning_snmp'
                control={control}
                defaultValue={false}
                render={({ field: { onChange, value } }) => (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={!!Number(value)}
                        onChange={onChange}
                        name='time_warning_snmp'
                      />
                    }
                    label='Send SNMP Trap'
                  />
                )}
              />
            </FormGroup>
          </FormControl>
        </Grid>
        <Grid container item xs={8} spacing={1}>
          <Grid item xs={12}>
            <Button
              variant='contained'
              color='primary'
              onClick={handleSubmit}
              fullWidth
              disabled={!hasChanges}
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
export default NotificationsSetup;
